import { render, staticRenderFns } from "./reset_training.vue?vue&type=template&id=52a7fd74&"
import script from "./reset_training.vue?vue&type=script&lang=js&"
export * from "./reset_training.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports